package de.oevbs.kunde.kundenportal2.services.contract.lineofbusiness

import de.oevbs.businesspartner.bpcrmservice2.contract.model.ContractDetails
import de.oevbs.businesspartner.bpcrmservice2.contract.model.lineofbusiness.Property
import de.oevbs.businesspartner.bpcrmservice2.contract.model.lineofbusiness.PropertyLegacy
import de.oevbs.businesspartner.bpcrmservice2.partner.model.toView
import de.oevbs.kunde.kundenportal2.components.collapsible
import de.oevbs.kunde.kundenportal2.components.detailsGrid
import de.oevbs.kunde.kundenportal2.components.detailsGridEntry
import de.oevbs.kunde.kundenportal2.components.detailsGridEntryValueList
import de.oevbs.kunde.kundenportal2.services.contract.*
import dev.fritz2.core.RenderContext


/**
 * Vertragsdetails der Sparte Sach
 * [details] und [property] liefern alle nötigen Informationen
 *
 * @param details beinhaltet die generellen Informationen
 * @param property beinhaltet die Sparten spezifischen Informationen
 */
fun RenderContext.contractDetailsProperty(details: ContractDetails, property: Property) {
    detailsSection("Ihr Versicherungsschutz") {
        detailsGrid {
            detailsGridEntry("Art der Versicherung", details.general.salesProduct)
            if (property.productVariant != null) detailsGridEntry("Variante", property.productVariant)
        }
    }
    if (property.declarations.isNotEmpty()) {
        div("flex flex-col gap-2") {
            property.declarations.forEach { declaration ->
                collapsible {
                    isRead(true)
                    headerLeft {
                        detailsGrid {
                            detailsGridEntry("Versicherungsort", declaration.address.toView(), longColumn = true)
                            detailsGridEntry("Bezeichnung", declaration.typeOfBuildingText)
                            detailsGridEntry("Baujahr", declaration.yearOfConstruction.toString())
                            detailsGridEntry("Außenwand", declaration.outerWallText)
                            detailsGridEntry("Bedachung", declaration.roofingText)
                            detailsGridEntry("Wohnfläche/Nutzfläche", "${declaration.activeArea} m²")
                            detailsGridEntry(
                                "Versicherungssumme",
                                "${declaration.insuredAmount.toEuro()} / ${declaration.objectValue.toInsuranceSum()} M1914"
                            )
                            detailsGridEntry("Versicherungswert", declaration.typeOfInsuredAmountText)
                        }
                    }
                    content {
                        div("flex flex-col gap-2") {
                            detailsGrid {
                                detailsGridEntry("Feuer", declaration.isFireIncluded.toJaNein())
                                detailsGridEntry("Leitungswasser", declaration.isWaterIncluded.toJaNein())
                                detailsGridEntry("Sturm / Hagel", declaration.isStormHailIncluded.toJaNein())
                                detailsGridEntry("weitere Naturgefahren", declaration.isNatureIncluded.toJaNein())
                                detailsGridEntry("Glas+", declaration.isGlassIncluded.toJaNein())
                            }
                            detailsGrid {
                                detailsGridEntry("Technik+", declaration.isTechnicsIncluded.toJaNein())
                                if (declaration.isLandlordIncluded != null) detailsGridEntry("Vermieter+", declaration.isLandlordIncluded!!.toJaNein())
                                detailsGridEntry("SofortService+", declaration.isServiceIncluded.toJaNein())
                                detailsGridEntry("Photovoltaik+", declaration.isPhotovoltaicEquipped.toJaNein())
                            }
                        }
                    }
                }
            }
        }
    }
}

/**
 * Vertragsdetails der Sparte Sach (Altsystem)
 * Aktuell werden alle Haushalt und Haushaltglas Verträge aus CRM heraus über [PropertyLegacy] abgebildet
 * [details] und [property] liefern alle nötigen Informationen
 *
 * @param details
 * @param property
 */
fun RenderContext.contractDetailsPropertyLegacy(details: ContractDetails, property: PropertyLegacy) {
    detailsSection("Ihr Versicherungsschutz") {
        detailsGrid {
            detailsGridEntry(
                "Art der Versicherung",
                "${details.general.salesProduct} ${property.product.value}",
                longColumn = true
            )
            detailsGridEntry("Versicherungsort", property.address.toView(), longColumn = true)
            if (property.insuranceSumText.isNotEmpty()) {
                detailsGridEntry("Versicherungssumme", "${property.insuranceSumText} €")
            }
            if (property.livingSpace > 0) {
                detailsGridEntry("Wohnfläche", "${property.livingSpace} m²")
            }
            detailsGridEntry(
                "Weitere Informationen",
                value = {
                    detailsGridEntryValueList {
                        property.risks.forEach { li { +it.riskText } }
                    }
                },
                longColumn = true
            )
        }
    }
}